/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {sendPoolContribution} from '../api'

export const useMutationSendPoolContribution = createReactQueryMutationHook('sendPoolContribution', sendPoolContribution)
